
ADILF.define('adilf/apps/social/util/subnav-highlighter',['require','exports','module','streamhub-sdk/jquery'],function (require, exports, module) {/* Add a highlight class to Pagebuilder Sub-Navigation module link,
if href matches current page URL */
'use strict';

var jquery = require('streamhub-sdk/jquery');

var SubnavHighlighter = function() {};

SubnavHighlighter.prototype.selectors = {
    'nav': '#news-river .sub-nav',
    'item': '#news-river .sub-nav .sub-nav-item'
};

SubnavHighlighter.prototype.parseURL = function(url) {
    /* Normalize http://www.aff.com/teamname/anything/index.html or /teamname/anything/ to
       teamname/anything */
    if(!url) return;
    url = url.replace('/index.html', '');
    if(url.substr(0, 4) === 'http') {
        var parts = url.split('/');
        url = parts.slice(3, parts.length).join('/');
    }
    if(url[0] === '/') url = url.substr(1, url.length);
    if(url[url.length-1] === '/') url = url.substr(0, url.length-1);
    return url;
};

SubnavHighlighter.prototype.highlight = function(href) {
    var self = this;
    href = this.parseURL(href) || this.parseURL(document.location.pathname);
    if(!jquery(this.selectors.nav).length) return;
    jquery.each(jquery(this.selectors.item), function(i, item) {
        if(self.parseURL(jquery(item).find('a').attr('href')) === href) {
            jquery(item).addClass('active');
        }
    });
};

module.exports = SubnavHighlighter;
});
